import {createRoot, hydrateRoot} from 'react-dom/client';
import ContactReserveSession from '../pages/ContactReserveSession/ContactReserveSession'
import "../index.css";
import "../pages/ContactReserveSession/ContactReserveSession.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<ContactReserveSession {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <ContactReserveSession {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).ContactReserveSessionVC = {mount, hydrate, unmount}